import { GlyphCache } from "../private/objects/labelCollection";
import { IFontAsset } from "../api";
export class FontAsset extends IFontAsset {
    constructor(loadedFont, textureSize, glyphSize) {
        super();
        this.loadedFont = loadedFont;
        this.cache = new GlyphCache(this.loadedFont.font, textureSize, glyphSize);
    }
}
